import { Typography } from '@mui/material';
import { get, useFormContext } from 'react-hook-form';

interface ErrorMessageProps {
    field: string;
    message?: string;
}

export function ErrorMessage({ field }: ErrorMessageProps) {
    const {
        formState: { errors },
    } = useFormContext();

    const fieldError = get(errors, field);
    if (!fieldError) {
        return null;
    }

    return (
        <Typography color="error" variant="caption">
            {fieldError.message?.toString()}
        </Typography>
    );
}
